<template>
  <div class="panel consultant">
    <h2 class="flex-row flex-align-center gap-xs sponsor-section">
      <div class="dot">2</div>
      <div>
        {{
          join.info.rep
            ? props.content.sponsor_picked
            : props.content.sponsor_unpicked
        }}
      </div>
      <i
        v-if="!join.info.rep"
        class="pi pi-question-circle"
        v-tooltip.top="sponsorHelp"
      />
      <i
        v-if="join.info.rep"
        @click="join.info.rep = undefined"
        class="pi pi-pen-to-square"
      />
    </h2>

    <template v-if="join.info.kit">
      <div v-if="join.info.rep">
        <div class="flex-row m-sm-t gap-md flex-align-center text-left">
          <ThumbnailedImage
            class="consultant-image"
            :alt="join.info.rep.name || 'consultant'"
            :images="join.info.rep.images"
            sizes="100px"
          />
          <div class="flex-column">
            <div>{{ join.info.rep.name }}</div>
            <div>{{ join.info.rep.rep_number }}</div>
            <div>{{ join.info.rep.email }}</div>
          </div>
        </div>
      </div>
      <RepSearch v-else v-model="join.info.rep" class="rep-search m-2xs-t" />
    </template>
  </div>
</template>

<script setup lang="ts" generic="T extends Record<string, string>">
import { useJoinStore } from "@/stores/join";
import RepSearch from "../rep/RepSearch.vue";
import ThumbnailedImage from "../ThumbnailedImage.vue";

const sponsorHelp = {
  value:
    "Select a Paparazzi Consultant to be your Sponsor. This should be the Consultant who introduced you to Paparazzi Accessories. If you were not referred by a Paparazzi Consultant, please use the search feature to find someone in your area.",
};
const join = useJoinStore();

const props = defineProps<{ content: T }>();
</script>

<style scoped>
i.pi {
  font-size: 12px;
}

@media (max-width: 945px) and (min-width: 801px) {
  .rep-search:deep(.flex-row) {
    flex-direction: column !important;
  }
  .reps-container {
    margin-top: var(--2XL, 72px);
  }
}
@media (max-width: 800px) {
  .rep-search:deep(.flex-row) {
    flex-direction: column !important;
  }
  .panel.consultant:deep(.auto-form .inside) {
    max-width: 100%;
  }
}
</style>
